import http from '@/services/api';

const RESOURCE_NAME = 'api/businessProcess';

export default {
  getBusinessProcessInformation(businessProcessId) {
    return http.get(`${RESOURCE_NAME}/${businessProcessId}`);
  },

  getBusinessProcessAssignments(businessProcessId) {
    return http.get(`${RESOURCE_NAME}/${businessProcessId}/assignments`);
  },

  getHealthConfigurationTemplates() {
    return http.get(`${RESOURCE_NAME}/health/configuration/templates`);
  },

  getHealthConfiguration(businessProcessId) {
    return http.get(`${RESOURCE_NAME}/${businessProcessId}/health/configuration`);
  },

  addHealthConfiguration(businessProcessId, configurationId) {
    return http.post(`${RESOURCE_NAME}/${businessProcessId}/health/configuration`, { configurationId });
  },

  activateAgents(businessProcessId, agentIds, duration) {
    return http.post(`${RESOURCE_NAME}/${businessProcessId}/assignments/activate`, { agentIds, duration });
  },

  deactivateAgents(businessProcessId, agentIds, duration) {
    return http.post(`${RESOURCE_NAME}/${businessProcessId}/assignments/deactivate`, { agentIds, duration });
  },

  setTemporaryAssignmentsExpiration(businessProcessId, expirationMinutes) {
    return http.post(`${RESOURCE_NAME}/${businessProcessId}/assignments/expiration`, { expirationMinutes });
  },

  getCrmTemplate(businessProcessId) {
    return http.get(`${RESOURCE_NAME}/${businessProcessId}/crm/template`);
  },

  getBusinessProcessStats() {
    return http.get(`${RESOURCE_NAME}/all/stats`);
  }
};
